import { Modal } from 'react-bootstrap';

import Button, { BUTTON_SIZE } from '../generic/Button';
import type { AlertDialogProps } from '../../contexts/DialogContext';

/**
 * Alert dialog. Replacement for window.alert.
 *
 * @param {string} title - Alert title.
 * @param {string | React.ReactElement} body - Alert body.
 * @param {() => void} onClose - Closes the modal.
 */
const AlertDialog = ({
  title,
  body,
  onClose,
}: Omit<AlertDialogProps, 'type'>) => (
  <Modal
    onHide={onClose}
    className="modal-confirm"
    backdrop
    show
  >
    <Modal.Header closeButton>
      <Modal.Title>
        {title}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {body}
    </Modal.Body>
    <Modal.Footer>
      <Button
        size={BUTTON_SIZE.MEDIUM}
        onClick={onClose}
      >
        Got It!
      </Button>
    </Modal.Footer>
  </Modal>
);

export default AlertDialog;
